import { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context"

export const AdminAuthGuard = () => {
  const navigate = useNavigate()
  const { user, isAdmin, homeRedirectUrl } = useAuth()

  useEffect(() => {
    if (!user) {
      void navigate("/login")
      return
    }
    if (!isAdmin) {
      void navigate(homeRedirectUrl)
    }
  }, [navigate, user, isAdmin, homeRedirectUrl])

  if (!user || !isAdmin) return null

  return <Outlet />
}
